<template>
  <div class="confirm-form">
    <div class="form-group">
      <h4 class="text-center">{{ inputLabel }}</h4>
      <!--  -->
      <div class="line"></div>
      <h6 class="text-center">藥盒數量 ({{this.selectedDrug.pack_content}} pc/盒)</h6>
      <input 
        class="form-control custom-input" 
        type="number"
        v-model="packCount" min="0" 
        @click="showPackPad = true"
        @keydown="showPackPad = true"
        ref="input" />
      <transition name="fade"> 
        <NumberInput v-if="showPackPad" v-on:saveNumber="savePackCount" :defaultNumber="defaultPackCount"/>
      </transition>
      <!--  -->
      <br>
      <h6 class="text-center">散藥數量（pc）</h6>
      <input 
        class="form-control custom-input" 
        type="number"
        v-model="pieceCount" min="0" 
        @click="showPiecePad = true"
        @keydown="showPiecePad = true"
        ref="input" />
      <transition name="fade"> 
        <NumberInput v-if="showPiecePad" v-on:saveNumber="savePieceCount" :defaultNumber="defaultPieceCount"/>
      </transition>
      <span class="total-amount--text">總數量：{{storageAmount}}</span>
    </div>
    <div class="button-wrap">
      <button class="btn btn-lg confirm-button" @click="setNum">確認</button>
    </div>
  </div>
</template>

<script>
import NumberInput from './NumberInput';

export default {
  name: 'PackAndPieceSet',
  props: {
    maxAmount: Number,
    defaultAmount: Number,
    defaultPackCount: Number,
    inputLabel: String,
    canBeZero: Boolean,
  },
  components: {
    NumberInput,
  },
  data() {
    return {
      packCount: 0,
      pieceCount: 0,
      showPackPad: false,
      showPiecePad: false,
    };
  },
  created() {
    // this.storageAmount = this.defaultAmount;
    // if (this.maxAmount) this.storageAmount = this.maxAmount;
  },
  mounted() {
    this.$refs.input.focus();
    this.autoCalcPackAndPiece();
  },
  computed: {
    selectedDrug() {
      return this.$store.getters.selectedDrug;
    },
    storageAmount() {
      return (this.packCount * this.selectedDrug.pack_content) + this.pieceCount;
    },
  },
  methods: {
    setNum() {
      if (this.maxAmount) {
        console.log(this.storageAmount > this.maxAmount);
        if (this.storageAmount > this.maxAmount) {
          this.$store.commit('SET_MESSAGE', { type: 'error', context: `設定數量不可大於最大庫存量 (${this.MaxAmount}).` });
        } else if (this.storageAmount === 0) {
          if (this.canBeZero) {
            this.emitData();
          } else {
            this.$store.commit('SET_MESSAGE', { type: 'error', context: '數量不可為0' });
          }
        } else {
          this.emitData();
        }
      } else {
        if (this.storageAmount === 0) {
          if (this.canBeZero) {
            this.emitData();
          } else {
            this.$store.commit('SET_MESSAGE', { type: 'error', context: '數量不可為0' });
          }
        } else {
          this.emitData();
        }
      }
    },
    emitData() {
      this.$emit('setNum', {
        packCount: this.packCount,
        pieceCount: this.pieceCount,
        amount: this.storageAmount,
      });
    },
    saveNumber(val) {
      this.storageAmount = val;
      this.showPad = false;
    },
    savePackCount(val) {
      this.packCount = val;
      this.showPackPad = false;
    },
    savePieceCount(val) {
      this.pieceCount = val;
      this.showPiecePad = false;
    },
    autoCalcPackAndPiece() {
      if (this.defaultPackCount === undefined) {
        if (this.selectedDrug.pack_content !== 0) {
          this.packCount = Math.floor(this.defaultAmount / this.selectedDrug.pack_content);
          this.pieceCount = this.defaultAmount % this.selectedDrug.pack_content;
        } else {
          this.packCount = 0;
          this.pieceCount = this.defaultAmount;
        }
      }
    },
  },
  watch: {
    packCount(val) {
      if (isNaN(val)) {
        this.packCount = 0;
      } else {
        this.packCount = val;
      }
    },
    pieceCount(val) {
      if (isNaN(val)) {
        this.pieceCount = 0;
      } else {
        this.pieceCount = val;
      }
    },
  },
};
</script>

<style lang="sass">
.line
  width: 30%
  border: 0.5px solid rgba(0,0,0,0.2)
  margin: 0 0 1rem 0 
.total-amount--text
  margin: 0.5rem
  text-
</style>



// WEBPACK FOOTER //
// PackAndPieceSet.vue?2c097fc4